export var StorageTypes;
(function (StorageTypes) {
    StorageTypes[StorageTypes["IndexedDB"] = 0] = "IndexedDB";
    StorageTypes[StorageTypes["LocalStorage"] = 1] = "LocalStorage";
    StorageTypes[StorageTypes["SessionStorage"] = 2] = "SessionStorage";
    StorageTypes[StorageTypes["NoOp"] = 3] = "NoOp";
})(StorageTypes || (StorageTypes = {}));
